import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Create client only if credentials are present
let supabase = null;
if (supabaseUrl && supabaseAnonKey) {
  supabase = createClient(supabaseUrl, supabaseAnonKey);
} else {
  console.warn(
    "Supabase config missing. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env"
  );
}

/**
 * Test Supabase connection (no tables required).
 * Returns { ok: boolean, message: string }.
 */
export async function testSupabaseConnection() {
  if (!supabase) {
    return {
      ok: false,
      message: "Supabase not configured (missing URL or anon key in .env)",
    };
  }
  try {
    const { error } = await supabase.auth.getSession();
    if (error) {
      return { ok: false, message: `Supabase error: ${error.message}` };
    }
    return { ok: true, message: "Connected to Supabase successfully." };
  } catch (err) {
    return {
      ok: false,
      message: err?.message || "Connection failed (network or CORS).",
    };
  }
}

export default supabase;
